import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import getCarriers from 'API/Carriers/getCarriers';

const useGetCarriers = () => {
    const { currentScope } = useSelector((state) => state.login);

    return useQuery({
        queryKey: ['carriers', currentScope],
        queryFn: async () => {
            return getCarriers(currentScope);
        },
        staleTime: 5 * 60 * 1000, // 5 minutes
    });
};

export default useGetCarriers;
